import Fetch from '../Fetch';
export default {
  downloadUrl: () => {//Tech Support
    return Fetch.get(`/api/v1/tech_support`, {responseType: 'blob'})
  },
  queryHttpPort: () => {//http port
    return Fetch.get(`/api/v1/ip_http`);
  },
  queryTerminal: (params, success, error) => {
    return Fetch.post(`/api/v1/terminal`,params);
  },
  queryShureInfo: () => {//shure
    return Fetch.get(`/api/v1/shure_activation`);
  },
  queryStacking: (success, error) => {//Stacking
    return Fetch.get(`/api/v1/stacking`);
  },
  queryDeviceXml: () => {//device info
    return Fetch.get(`/rootDesc.xml`, {responseType: 'text'})
  },
  saveConfiguration: (params) => {//save config
    return Fetch.post(`/api/v1/nvram_factory_default`,params);
  },
  eraseConfiguration: (params) => {//erase config
    return Fetch.post(`/api/v1/nvram_factory_default_erase`,params);
  },
}
